import { render, staticRenderFns } from "./CreateCollaboratorForm.vue?vue&type=template&id=2eddc0f9&"
import script from "./CreateCollaboratorForm.vue?vue&type=script&lang=js&"
export * from "./CreateCollaboratorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports